import { useTranslation } from 'react-i18next';

import { camelCasify } from '../../../../utils/navigation';
import useRegistrationForm from '../../../registration/useRegistrationForm';
import { useRegistrationSteps } from '../../hooks/useRegistrationSteps';

import { Dot, Step, StepContainer, StepLabel, StyledCheckmarkIcon } from './styledComponents';

const CheckedDot = () => (
  <Dot $isCompleted>
    <StyledCheckmarkIcon title="a11y-title" />
  </Dot>
);

export const Stepper = () => {
  const { t } = useTranslation();
  const { step: currentStep } = useRegistrationForm();
  const { steps, currentStepIndex } = useRegistrationSteps(currentStep);

  return (
    <StepContainer>
      {steps.map((step, index) => {
        const isCurrentStep = step === currentStep;
        const isCompleted = index < currentStepIndex;
        const stepNumber = index + 1;

        return (
          <Step key={step}>
            {isCompleted ? <CheckedDot /> : <Dot $isActive={isCurrentStep}>{stepNumber}</Dot>}
            <StepLabel $isActive={isCurrentStep} data-size="sm">
              {t(`register.step.${camelCasify(step)}`)}
            </StepLabel>
          </Step>
        );
      })}
    </StepContainer>
  );
};
